import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ReactComponent as Name_Tag } from "../assets/icons/arrowDown.svg";
import { ReactComponent as SeparatorDots } from "../assets/icons/separatorDots.svg";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import PrimaryButton from "../Components/PrimaryButton";
import InputField from "../Components/InputField";
import TextArea from "../Components/TextArea";
import SubmitButton from "../Components/SubmitButton";
import CustomCarousel from "../Components/home/Carousel";
import Lightbox from "../Components/Lightbox";

import { dataCarousel } from "../Components/Data/dataCarousel";

import introHero from  "../assets/home/gif-file/FullLogo-longVersion.mp4"
import loopingHero from  "../assets/home/gif-file/LogoEndLoop.webm"

import nandan from "../assets/home/avatars/nandanAvatar.png";
import tito from "../assets/home/avatars/titoAvatar.png";
import ari from "../assets/home/avatars/arianaAvatar.png";
import reel from "../assets/cursor/demoReelCursor.gif";
import noise from "../assets/cursor/bwNoise.gif";
import demoReel from "../assets/home/video/FV2Reel-2025-V001.mp4";

function Home() {
  const navigate = useNavigate();

  // Ref vars
  const titleOneRef = useRef(null);
  const titleTwoRef = useRef(null);
  const nandanRef = useRef(null);
  const titoRef = useRef(null);
  const ariRef = useRef(null);
  const videoRef = useRef(null);
  const arrowRef = useRef(null);

  // useStates
  const [message, setMessage] = useState();
  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const [subject, setSubject] = useState();
  const [displayedText, setDisplayedText] = useState('');
  const [displayedText2, setDisplayedText2] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLooping, setIsLooping] = useState(false);

  // Vars for title animations
  let welcomeTitle = "Hi!";
  let contactUsFormTitle = "Ready to connect?";
  let welcomeSpeed = 150;
  let contactUsSpeed = 100;

  /**
   * Check when the hero video has ended, then switch the video
   */
  const handleVideoEnd = () => {
    let videoElement = videoRef.current;
    let arrowElement = arrowRef.current;

    arrowElement.classList.remove('hidden');
    videoElement.remove();
    // videoElement.load();
    // videoElement.play();
    setIsLooping(true);
  };

  /**
   * Navigates the user to the works page.
   */
  const onSeeMoreClick = () => {
    setIsModalOpen(true);
  };

  /**
   * Navigates the user to home.
   */
  const onSendClick = () => {
    navigate("/");
  };

  const onTeamClick = () => {
    navigate("/team");
  };

  const onProjectClick = () => {
    navigate("/projects");
  };

  /**
   * Clears the input fields in the contact us form.
   */
  const onClearClick = () => {
    setMessage("");
    setName("");
    setEmail("");
    setSubject("");
  };

  /**
   * Animation handler for the "Hi!" title.
   */
  const handleTitleOneIntersect = () => {
    let i = 0;
  
    // Typing animation
    const interval = setInterval(() => {
      setDisplayedText(welcomeTitle.substring(0, i));

      i++;

      if (i > welcomeTitle.length) {
        clearInterval(interval);
      }
    }, welcomeSpeed);
  };

  /**
   * Aniamation handler for the "Ready to connect?" title.
   */
  const handleTitleTwoIntersect = () => {
    let i = 0;

    // Typing animation
    const interval = setInterval(() => {
      setDisplayedText2(contactUsFormTitle.substring(0, i));
      
      i++;
      
      if (i > contactUsFormTitle.length) {
        clearInterval(interval);
      }
    }, contactUsSpeed);
    return () => clearInterval(interval);
  }

  /**
   * Animation handler for the services avatars.
   */
  const handleServiceAvatarIntersect = () => {
    let nandanElement = nandanRef.current;
    let titoElement = titoRef.current;
    let ariElement = ariRef.current;

    // If animation already ran, do not run again
    if (nandanElement.classList.contains('bounce-in-up-fade') || ariElement.classList.contains('bounce-in-up-fade')) {
      return;
    }

    // Segregate reveals of each avatar
    nandanElement.classList.add('bounce-in-up-fade');
    setTimeout(() => {
      ariElement.classList.add('bounce-in-up-fade');
      setTimeout(() => {
        titoElement.classList.add('bounce-in-up-fade');
      }, 100);
    }, 100);
  }

  // Link animation handlers to a target ref. When ref enters the user's viewport, the onIntersect handler will run.
  const sectionRefs = [
    { ref: titleOneRef, onIntersect: handleTitleOneIntersect },
    { ref: titleTwoRef, onIntersect: handleTitleTwoIntersect },
    { ref: nandanRef, onIntersect: handleServiceAvatarIntersect },
    { ref: ariRef, onIntersect: handleServiceAvatarIntersect },
  ];

  /**
   * General observer hook to wait for the elements in sectionRefs to appear within the viewport before running the logic in onIntersect.
   * onIntersect is always a function describing an animation for a DOM element.
   */
  useEffect(() => {
    const observers = [];
  
    // Observe every target ref to wait for them to enter the user's viewport
    sectionRefs.forEach(({ ref, onIntersect }) => {
      const element = ref.current;

      if (!element) {
        return;
      }
  
      const observer = new IntersectionObserver(
        ([entry]) => {
          // If the object intersects, run the passed handler. 
          // Then, unobserve the target ref to only animation run once.
          if (entry.isIntersecting) {
            onIntersect();
            observer.unobserve(entry.target);
          }
        },
        { threshold: 0.5 }
      );
  
      observer.observe(element);
      observers.push(observer);
    });
  
    // Cleanup all observers
    return () => {
      observers.forEach((observer, index) => {
        const el = sectionRefs[index].ref.current;
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  /**
   * Creates the image-wrapper portion of the React Responsive Carousel dynamically using the data
   * stored in dataCarousel.
   *  
   * @returns {DOMElement} image-wrapper element of the React Responsive Carousel
   */
  const renderCarousel = () => {
    return dataCarousel.map((item, index) => (
      <div className='image-wrapper' key={index}>
        <img src={item.image} alt='project image' className='image' />
        {/* <img src={shadow} alt='shadow' className='shadow' /> */}
        {/* <div className="title-wrapper">
          <h3 className='project-title'>{item.title}</h3>
          <p className='project-description'>{item.description}</p>
        </div> */}
      </div>
    ));
  };

  /**
   * Display the demo reel sneak peak in the cursor display.
   */
  const showReel = () => {
    document.querySelector('.overlay').style.backgroundImage = `url(${reel})`;
  }

  /**
   * Hide the demo reel sneak peak in the cursor display.
   */
  const hideReel = () => {
    document.querySelector('.overlay').style.backgroundImage = `url(${noise})`;
  }

  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  /**
   * Monitor when the esc key is pressed and close the menu
   */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        setIsModalOpen(false);
      }
    };
  
    window.addEventListener('keydown', handleKeyDown);
  
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  const videoRef2 = useRef(null);
  const [progress, setProgress] = useState(0); // value 0 - 100

  /**
   * Update the progress bar as the video plays.
   */
  const handleTimeUpdate = () => {
    const video = videoRef2.current;

    if (video && video.duration) {
      const current = (video.currentTime / video.duration) * 100;
      setProgress(current);
    }
  };

  /**
   * Handle user click on progress bar. Skips video to where clicked on progress bar.
   * 
   * @param {Event} e 
   */
  const handleSeek = (e) => {
    const rect = e.target.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;
    const percentage = clickX / width;

    const video = videoRef2.current;

    if (video && video.duration) {
      video.currentTime = percentage * video.duration;
    }
  };

  return (
    <>
      <h1 className="seo-only">About Final Version 2</h1>
      <h2 className="seo-only">Learn more about Vancouver-based post-production studio Final Version 2. Browse our services and past projects, or contact us!</h2>

      <div className='home'>
        {/* Video */}
        <div className='gif-section'>
          <video
            ref={videoRef}
            src={introHero}
            className="hero"
            autoPlay
            muted
            playsInline
            preload="auto"
            onEnded={handleVideoEnd}
            style={{zIndex: 3}}
          />
          <video
            src={loopingHero}
            className="hero"
            autoPlay
            muted
            playsInline
            preload="auto"
            loop
            style={{zIndex: 2}}
          />

          <Name_Tag ref={arrowRef} className="arrow hidden" />
        </div>

        {/* Description */}
        <div className="description-section">
          <div className="left-column">
            <h2 className="title" ref={titleOneRef}>{displayedText}<span className="underscore">_</span></h2>
          </div>
          <div className="right-column">
            <p className="text">
              We’re Final Version 2 (FV2), a Vancouver-based post-production studio working across visual effects & motion graphics.
            </p>
            <p className="text">
              FV2 was born out of a need for a space where process didn’t kill play. A space that doesn’t aim to be bigger or louder, just better.
              Better for the work, and for the people behind it.
            </p>
            <p className="text">
              Let’s make your FNL_VER_002.proj !!
            </p>
            {/* <p className="text highlighted" onMouseEnter={showReel} onMouseLeave={hideReel} onClick={onSeeMoreClick}>
              View our demo reel! -{'>'}
            </p> */}
            <div className='buttons'>
              <PrimaryButton
                label={"Reel"}
                variant={"primary-btn"}
                onClick={onSeeMoreClick}
                onMouseEnter={showReel} 
                onMouseLeave={hideReel}
              />
              <PrimaryButton
                label={"Team"}
                variant={"primary-btn"}
                onClick={onTeamClick}
              />
            </div>
          </div>
        </div>

        <SeparatorDots className="separator_dots"/>

        {/* Services */}
        <div className="services-section">
          <ul className='services'>
            <li>
              <img ref={nandanRef} className="avatars" src={nandan} alt="visual effects avatar" />
              <h3 className='service-title'> Visual Effects </h3>
              <p className='service-description'>
                Let's fix those green screens, or how about little compositing magic? Perhaps, you're looking to show off your product in 3D space?
              </p>
            </li>
            <li>
              <img ref={titoRef} className="avatars" src={tito} alt="motion graphics avatar" />
              <h3 className='service-title'> Motion Graphics </h3>
              <p className='service-description'>
                Title sequences set the stage for the story. Those text bubbles help translate the story. UI/HUDs could be the story itself!
              </p>
            </li>
            <li>
              <img ref={ariRef} className="avatars" src={ari} alt="production avatar" />
              <h3 className='service-title'> Production </h3>
              <p className='service-description'>
                We can help you plan Virtual Production and take care of on-set VFX. Our kit bag is a kit room; get gear for your production needs!
              </p>
            </li>
          </ul>
        </div>

        <SeparatorDots className="separator_dots"/>

        {/* Carousel */}
        <div className='carousel-section'>
          {/* <h2 className='carousel-title'>Peek at what's new!</h2> */}
          <CustomCarousel/>

          <div className='carousel-container'>
            <Carousel
              autoPlay={true}
              interval={3000}
              infiniteLoop={true}
              showArrows={false}
              showThumbs={false}
              showIndicators={true}
              showStatus={false}>
              {renderCarousel()}
            </Carousel>
            <div className='buttons'>
              <PrimaryButton
                label={"View More"}
                variant={"primary-btn"}
                onClick={onProjectClick}
              />
            </div>
            {/* <p className='details' onClick={onProjectClick}>View More -{'>'}</p> */}
          </div>
        </div>

        <SeparatorDots className="separator_dots"/>

        {/* Contact Us */}
        <div className='contactus-section typing-text' id='contact'>
          <div className="left-column-contact-us">
            <h2 ref={titleTwoRef}>{displayedText2}<span className="underscore">_</span></h2>
          </div>
          <div className="right-column-contact-us">
            <form
              action='https://formspree.io/f/mbjevdyo'
              method='post'
              className='form'>
              <div className='name-email'>
                <InputField
                  label={"Name"}
                  type={"text"}
                  onChange={(e) => setName(e.target.value)}
                  name={"name"}
                  value={name}
                />
                <InputField
                  label={"Email"}
                  type={"email"}
                  onChange={(e) => setEmail(e.target.value)}
                  name={"email"}
                  value={email}
                />
              </div>
              <InputField
                label={"Subject"}
                type={"text"}
                onChange={(e) => setSubject(e.target.value)}
                name={"subject"}
                value={subject}
              />
              <TextArea
                label={"Message"}
                type={"textArea"}
                onChange={(e) => setMessage(e.target.value)}
                name={"message"}
                value={message}
              />
              <div className='buttons'>
                <SubmitButton
                  label={"Send"}
                  variant={"primary-btn"}
                  onClick={() => onSendClick()}
                />
                <PrimaryButton
                  label={"Clear"}
                  variant={"primary-btn"}
                  onClick={onClearClick}
                />
              </div>
            </form>
          </div>
        </div>

        {/* Lightbox */}
        <Lightbox isOpen={isModalOpen} onClose={closeModal}>
          <>
            <div className="work-video">
              <video
                  src={demoReel}
                  ref={videoRef2}
                  className="work-video"
                  alt="lightboxVideo"
                  autoPlay
                  // muted
                  loop
                  playsInline
                  onTimeUpdate={handleTimeUpdate}
              />
              <div className="progress-bar-container" onClick={handleSeek}>
              <div
                className="progress-bar"
                style={{ width: `${progress}%` }}
              />
            </div>
            </div>
          </>
        </Lightbox>
      </div>
    </>
  )
}

export default Home;